import { useRouter } from 'next/router';

export const Panel = () => {
  const router = useRouter();

  return (
    <img
      src={`${router.basePath}/assets/img/digital-plan-panel.webp`}
      alt="Digital plan panel"
    />
  );
};
